import axios from "axios";
import Config from "@/Config.js";

const BASE = Config.host + "Settings";

/**
 * Configuracion de la plataforma. Solo ver y editar: las filas nacen de las
 * semillas del backend, no de la pantalla, asi que aqui no hay crear ni
 * eliminar a proposito.
 */
export default {
  getAll() {
    return axios.get(`${BASE}`).then((r) => r.data);
  },
  /** Solo las marcadas como publicas. No exige sesion. */
  getPublic() {
    return axios.get(`${BASE}/public`).then((r) => r.data);
  },
  getByKey(key) {
    return axios.get(`${BASE}/${key}`).then((r) => r.data);
  },
  /** Solo el valor: la clave y el tipo los manda el modelo, no el formulario. */
  updateValue(key, value) {
    return axios.put(`${BASE}/${key}`, { value }).then((r) => r.data);
  },
};
